import React, { useCallback, FunctionComponent } from "react"
import { PhotoItem } from "@albelli/photoselector"
import { Title, ImageCount } from "../Overlays"

export interface PhotoOrganiserItem extends PhotoItem {
  name: string
  imageCount?: number
  similarCount?: number
  dateFrom?: string
  source: string
}

interface PhotoOrganiserItemProps {
  item: PhotoOrganiserItem
  navigateTo: (id: string) => void
  children?: React.ReactChild
}

// Component for rendering category items. Can pass custom components (overlays) to be rendered as children
export const CategoryItemContainer: FunctionComponent<PhotoOrganiserItemProps> = ({ item, navigateTo, children }) => {
  const handleClick = useCallback(() => navigateTo(item.id), [])
  const style = { backgroundImage: `url(${item.urlPreview})` }
  return (
    <div className="photoselector-photo-organiser__item desktop" title={item.name} style={style} onClick={handleClick}>
      <Title>{item.name}</Title>
      <ImageCount>{item.imageCount}</ImageCount>
      {children}
    </div>
  )
}
